var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"avatar",class:_vm.classes},[(_vm.image)?_c('img',{attrs:{"src":_vm.image}}):_vm._e(),(!_vm.image)?_c('span',[_vm._v(_vm._s(_vm.firstLetter))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }